// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__22xfq","footer":"ModalUpdate_footer__oihqj"};